export const TOAST_MESSAGES_DELETE_COLUMN = {
  DELETE_COLUMN_ERROR: 'Error delete column, please try again',
  DELETE_COLUMN_SUCCESS: 'Column deleted successfully!',
};

export const BANNER_TITLE = 'Please double-check before deleting. This action is permanent.';

export const DESCRIPTION = (
  <>
    Are you sure you want to delete this column? <br /> Deleting this column will also{' '}
    <strong className="font-bold">permanently remove all tickets</strong> inside it.
  </>
);
